// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"c9821bca","423":"6035c8b4","535":"2ef59fec","668":"5e50698e","743":"b495c6a9","917":"a2a1f03b"}[chunkId] + ".chunk.js";
};